/**
 * Checkout Auth - Steps de Login/Cadastro
 */

(function ($) {
  "use strict";

  // ===== INTENT DO USUÁRIO =====
  // Guarda o ÚLTIMO método que o usuário clicou explicitamente. Diferente
  // de __lastConfirmedShippingMethod (que é atualizado por qualquer save,
  // incluindo o auto-save inicial), este só muda em interação humana.
  window.__userIntentShippingMethod = null;

  // Captura cliques humanos nos radios de entrega — fonte de verdade do que
  // o usuário REALMENTE quer, independente de re-renders silenciosos.
  document.addEventListener(
    "click",
    function (e) {
      const target = e.target;
      if (
        target &&
        target.tagName === "INPUT" &&
        target.type === "radio" &&
        target.name === "shipping_method[0]"
      ) {
        window.__userIntentShippingMethod = target.value;
      } else {
        // Clique em label que envolve um radio
        const label = target && target.closest && target.closest("label");
        if (label) {
          const radio = label.querySelector(
            'input[type="radio"][name="shipping_method[0]"]',
          );
          if (radio) {
            window.__userIntentShippingMethod = radio.value;
          }
        }
      }
    },
    true,
  );

  // ===== GUARDIÃO DA SELEÇÃO DE FRETE =====
  // Reaplica o intent do usuário no radio se algum hook re-renderiza/reverte
  // sem que o usuário tenha clicado em outro. Usa USER INTENT (fonte de
  // verdade humana), não __lastConfirmed (que é populado por qualquer save).
  setInterval(function () {
    const desired = window.__userIntentShippingMethod;
    if (!desired) return;
    const $shipping = $("#authStepShipping");
    if (!$shipping.length || !$shipping.hasClass("active")) return;

    const currentVal = document.querySelector(
      'input[name="shipping_method[0]"]:checked',
    )?.value;

    if (currentVal === desired) return;

    const target = document.querySelector(
      `input[name="shipping_method[0]"][value="${desired}"]`,
    );
    if (target) {
      // Marca SEM disparar change (evita loop com updateTotal).
      document
        .querySelectorAll('input[name="shipping_method[0]"]')
        .forEach((r) => (r.checked = false));
      target.checked = true;
      const hidden = document.getElementById("shipping_method_0");
      if (hidden) hidden.value = desired;
    }
  }, 500);

  const CheckoutAuth = {
    userData: {
      fullName: "",
      email: "",
      phone: "",
      cpf: "",
      birthdate: "",
      password: "",
      isRegistered: false, // Flag para saber se já registrou
    },
    bootFallbackTimer: null,
    addAddressModalWheelHandler: null,
    addAddressModalElement: null,

    // ===== ROTEAMENTO DE ETAPAS NA URL (finalizar-compra/{slug}) =====
    // Caminho base da página do checkout (ex.: "/finalizar-compra"), sem o
    // slug de etapa. Calculado em initStepRouting().
    checkoutBasePath: null,
    _popstateBound: false,

    // Painel (auth-step) -> slug exibido na URL.
    // IMPORTANTE: manter em sincronia com jabuticaba_checkout_step_slugs()
    // em functions/woocommerce/checkout-step-routing.php.
    STEP_ID_TO_SLUG: {
      authStepInitial: "dados",
      authStepRegister: "cadastre-se",
      authStepLogin: "entrar",
      authStepConfirm: "dados",
      authStepSelectAddress: "endereco",
      authStepAddress: "endereco",
      authStepShipping: "entrega",
      authStepPayment: "pagamento",
    },

    // Slug -> número da etapa visual (indicador do topo).
    STEP_SLUG_TO_NUMBER: {
      dados: 1,
      "cadastre-se": 1,
      entrar: 1,
      endereco: 2,
      entrega: 3,
      pagamento: 4,
    },

    init: function () {
      this.bindEvents();
      this.initPhoneMask();
      this.initCepMask();
      this.initBirthdateMask();
      this.initCepSearch();
      this.setupInitialVisibility();
      this.watchStepChanges(); // Observa mudanças nos steps
      this.initStepRouting(); // Roteamento de etapas na URL

      // Restaura a etapa a partir da URL para VISITANTES.
      // (Usuário logado é restaurado pelo bootstrap inline em page-checkout.php,
      //  que roda depois de carregar os dados da conta.)
      if ($("#pageCheckoutNew").data("checkoutUserState") !== "logged-in") {
        this.restoreStepFromUrl("authStepInitial");
      }
    },

    setupInitialVisibility: function () {
      const $page = $("#pageCheckoutNew");
      if (!$page.length) {
        return;
      }

      if (this.bootFallbackTimer) {
        clearTimeout(this.bootFallbackTimer);
      }

      this.bootFallbackTimer = setTimeout(() => {
        this.markCheckoutReady();
      }, 1500);

      if ($page.data("checkoutUserState") !== "logged-in") {
        this.markCheckoutReady();
      }
    },

    markCheckoutReady: function () {
      const $page = $("#pageCheckoutNew");
      if (!$page.length || $page.hasClass("is-ready")) {
        return;
      }

      if (this.bootFallbackTimer) {
        clearTimeout(this.bootFallbackTimer);
        this.bootFallbackTimer = null;
      }

      window.requestAnimationFrame(() => {
        $page.removeClass("is-booting").addClass("is-ready");
      });
    },

    // ===================================================================
    // Roteamento de etapas na URL (finalizar-compra/{slug})
    // ===================================================================

    /**
     * Calcula o caminho base do checkout e registra o listener de popstate.
     */
    initStepRouting: function () {
      const $page = $("#pageCheckoutNew");

      // Só o checkout tem etapa na URL. Fora dele, o fallback abaixo pegaria
      // o pathname da página atual e deixaria a URL como /{pagina}/dados (404).
      if (!$page.length) {
        this.checkoutBasePath = null;
        return;
      }

      const baseUrl = ($page.data("checkoutBaseUrl") || "").toString();
      try {
        this.checkoutBasePath = baseUrl
          ? new URL(baseUrl, window.location.origin).pathname.replace(/\/$/, "")
          : null;
      } catch (err) {
        this.checkoutBasePath = null;
      }

      if (!this.checkoutBasePath) {
        // Fallback: deriva do pathname atual removendo o slug de etapa.
        this.checkoutBasePath = window.location.pathname
          .replace(
            /\/(dados|cadastre-se|entrar|endereco|entrega|pagamento)\/?$/,
            "",
          )
          .replace(/\/$/, "");
      }

      this.bindPopstate();
    },

    /**
     * Slug de URL para um painel (auth-step).
     */
    getSlugForStep: function (stepId) {
      return this.STEP_ID_TO_SLUG[stepId] || null;
    },

    /**
     * Escreve a URL da etapa no histórico do navegador.
     *
     * @param {string} stepId  Painel ativo (ex.: "authStepShipping").
     * @param {string} mode    "push" (avanço, cria entrada) ou "replace"
     *                         (carga inicial / correção, sem nova entrada).
     */
    syncUrlForStep: function (stepId, mode) {
      if (!this.checkoutBasePath) return;

      const slug = this.getSlugForStep(stepId);
      if (!slug) return;

      const targetPath = this.checkoutBasePath + "/" + slug + "/";

      // Já estamos nesta URL: não duplica entrada nem reescreve à toa.
      if (window.location.pathname === targetPath) return;

      const newUrl = targetPath + window.location.search + window.location.hash;
      const prevDepth =
        (window.history.state && window.history.state.__checkoutDepth) || 0;

      if (mode === "replace") {
        window.history.replaceState(
          { __checkoutStep: stepId, __checkoutDepth: prevDepth },
          "",
          newUrl,
        );
      } else {
        window.history.pushState(
          { __checkoutStep: stepId, __checkoutDepth: prevDepth + 1 },
          "",
          newUrl,
        );
      }
    },

    /**
     * Lê o slug de etapa do pathname atual (vazio se estiver na raiz).
     */
    getSlugFromUrl: function () {
      const match = window.location.pathname.match(
        /\/(dados|cadastre-se|entrar|endereco|entrega|pagamento)\/?$/,
      );
      return match ? match[1] : "";
    },

    /**
     * Resolve o painel (auth-step) correto para um slug, respeitando o estado
     * atual (logado/visitante e existência de endereço). Impede deep-links
     * para etapas às quais o usuário ainda não pode chegar.
     */
    resolveStepIdForSlug: function (slug) {
      const $page = $("#pageCheckoutNew");
      const number = this.STEP_SLUG_TO_NUMBER[slug];
      if (!number) return null;

      const loggedIn = $page.data("checkoutUserState") === "logged-in";
      const hasAddress =
        $page.data("checkoutHasAddress") === true ||
        $page.data("checkoutHasAddress") === 1 ||
        $page.data("checkoutHasAddress") === "1" ||
        Boolean(this.selectedAddress) ||
        $(".select-address-card").length > 0;

      // Visitante ainda não autenticado só pode estar na etapa 1.
      if (!loggedIn) {
        if (number > 1) return "authStepInitial";
        if (slug === "cadastre-se") return "authStepRegister";
        if (slug === "entrar") return "authStepLogin";
        return "authStepInitial";
      }

      // Entrega/Pagamento exigem endereço; sem endereço, cai no cadastro dele.
      if (number >= 3 && !hasAddress) return "authStepAddress";

      switch (number) {
        case 1:
          return "authStepConfirm";
        case 2:
          return hasAddress ? "authStepSelectAddress" : "authStepAddress";
        case 3:
          return "authStepShipping";
        case 4:
          return "authStepPayment";
        default:
          return null;
      }
    },

    /**
     * Painel inicial a exibir com base na URL, ou o padrão informado.
     */
    resolveInitialStep: function (defaultStepId) {
      const $page = $("#pageCheckoutNew");
      const slug =
        ($page.data("checkoutStep") || "").toString() || this.getSlugFromUrl();
      if (!slug) return defaultStepId;

      const stepId = this.resolveStepIdForSlug(slug);
      return stepId || defaultStepId;
    },

    /**
     * Mostra a etapa vinda da URL sem criar entrada de histórico extra.
     */
    restoreStepFromUrl: function (defaultStepId) {
      const target = this.resolveInitialStep(defaultStepId);
      this.showStep(target, { urlMode: "replace" });
    },

    /**
     * Botão voltar/avançar do navegador: renderiza a etapa da URL destino
     * sem reescrever o histórico (skipUrl).
     */
    bindPopstate: function () {
      if (this._popstateBound) return;
      this._popstateBound = true;

      window.addEventListener("popstate", () => {
        const slug = this.getSlugFromUrl();
        const stepId = slug
          ? this.resolveStepIdForSlug(slug)
          : this.getNavigationStepTarget(1);

        if (stepId && $("#" + stepId).length) {
          this.showStep(stepId, { skipUrl: true });
        }
      });
    },

    /**
     * Atualiza os indicadores de step no header
     */
    getCurrentActiveStepNumber: function () {
      const stepMapping = {
        authStepConfirm: 1,
        authStepSelectAddress: 2,
        authStepAddress: 2,
        authStepShipping: 3,
        authStepPayment: 4,
      };

      let activeStepNumber = 1;
      $(".auth-step.active").each(function () {
        const stepId = $(this).attr("id");
        if (stepMapping[stepId]) {
          activeStepNumber = stepMapping[stepId];
        }
      });

      return activeStepNumber;
    },

    updateStepIndicator: function () {
      // Mapeamento de steps para números
      const stepMapping = {
        authStepConfirm: 1,
        authStepSelectAddress: 2,
        authStepAddress: 2, // Address também é step 2
        authStepShipping: 3,
        authStepPayment: 4,
      };

      // Encontra qual step está ativo
      let activeStepNumber = 1; // Default
      $(".auth-step.active").each(function () {
        const stepId = $(this).attr("id");
        if (stepMapping[stepId]) {
          activeStepNumber = stepMapping[stepId];
        }
      });

      activeStepNumber = this.getCurrentActiveStepNumber();

      // Remove estados anteriores
      $(".step-item").removeClass("active completed");

      // Marca passos anteriores como concluídos
      $(".step-item").each(function () {
        const stepNumber = Number($(this).data("step"));
        if (stepNumber < activeStepNumber) {
          $(this).addClass("completed");
        }
      });

      // Adiciona active no step correto
      $(`.step-item[data-step="${activeStepNumber}"]`).addClass("active");

      // Somente no mobile: esconde steps anteriores ao ativo

      const $mobileIndicator = $(
        ".checkout-header-mobile .checkout-steps-indicator",
      );
      $mobileIndicator.find(".step-item").each(function () {
        const stepNumber = Number($(this).data("step"));
        if (stepNumber < activeStepNumber) {
          $(this).hide();
          $(this).next(".step-divider").hide();
        } else {
          $(this).show();
          $(this).next(".step-divider").show();
        }
      });

      if (window.innerWidth <= 550) {
        const indicatorWidths = {
          1: "550px",
          2: "380px",
          3: "250px",
        };

        const mobileWidth = indicatorWidths[activeStepNumber] || "";
        $(".checkout-steps-indicator").css("width", mobileWidth);
      } else {
        $(".checkout-steps-indicator").css("width", "");
      }

    },

    /**
     * Observa mudanças nos steps usando MutationObserver
     */
    watchStepChanges: function () {
      const self = this;

      // Observa mudanças na classe "active" dos auth-steps
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class"
          ) {
            const $target = $(mutation.target);
            if ($target.hasClass("auth-step") && $target.hasClass("active")) {
              self.updateStepIndicator();
            }
          }
        });
      });

      // Configura o observer para observar todos os auth-steps
      $(".auth-step").each(function () {
        observer.observe(this, {
          attributes: true,
          attributeFilter: ["class"],
        });
      });

      // Atualiza o indicador inicial
      this.updateStepIndicator();
    },

    bindEvents: function () {
      // Botões de navegação entre steps
      $(document).on("click", "#btnShowRegisterForm", () =>
        this.showStep("authStepRegister"),
      );
      $(document).on("click", "#btnShowLoginForm", () =>
        this.showStep("authStepLogin"),
      );
      $(document).on("click", "#linkShowLoginFromRegister", (e) => {
        e.preventDefault();
        this.showStep("authStepLogin");
      });
      $(document).on("click", "#linkShowRegisterFromLogin", (e) => {
        e.preventDefault();
        this.showStep("authStepRegister");
      });
      $(document).on("click", "#linkChangeAccount", (e) => {
        e.preventDefault();

        const $link = $(e.currentTarget);
        const originalText = $link.text();
        $link.text("Saindo...").css("pointer-events", "none");

        // Faz logout do usuário atual antes de permitir novo cadastro
        $.ajax({
          url: checkoutCartParams.ajax_url,
          type: "POST",
          data: {
            action: "checkout_logout_user",
            nonce: checkoutCartParams.nonce,
          },
          success: (response) => {
            if (response.success) {
              // Limpa dados locais
              this.userData = {
                fullName: "",
                email: "",
                phone: "",
                password: "",
                isRegistered: false,
              };
              this.clearForm();

              // Esconde todo conteúdo de checkout logado
              $(".checkout-logged-content").hide();

              // Mostra e reseta o auth box
              const $authBox = $(".checkout-auth-box").first();
              $authBox.show();

              // Volta para step inicial
              this.showStep("authStepInitial");

              this.showNotification(
                "Você foi deslogado. Pode cadastrar uma nova conta.",
                "success",
              );

              $link.text(originalText).css("pointer-events", "auto");
            }
          },
          error: (xhr) => {
            console.error("Erro ao fazer logout:", xhr);
            this.showNotification("Erro ao sair. Tente novamente.", "error");
            $link.text(originalText).css("pointer-events", "auto");
          },
        });
      });

      // Toggle senha
      $(document).on("click", ".toggle-password", this.togglePassword);

      // Submit forms
      $(document).on(
        "submit",
        "#formRegisterCheckout",
        this.handleRegister.bind(this),
      );
      $(document).on(
        "submit",
        "#formLoginCheckout",
        this.handleLogin.bind(this),
      );
      $(document).on(
        "click",
        "#btnConfirmData",
        this.handleConfirmData.bind(this),
      );
      $(document).on(
        "submit",
        "#formAddressCheckout",
        this.handleSaveAddress.bind(this),
      );

      // Editar dados na confirmação
      $(document).on("click", ".btn-edit-data", this.handleEditData.bind(this));

      // Event listeners para modais e endereços
      $(document).on(
        "click",
        "#btnAddNewAddress",
        this.handleAddNewAddressFromShipping.bind(this),
      );
      $(document).on(
        "click",
        "#closeModalAddAddress, #btnCancelNewAddress",
        this.closeAddAddressModal.bind(this),
      );
      $(document).on("click", ".modal-overlay", this.closeAllModals.bind(this));
      $(document).on(
        "submit",
        "#formAddNewAddress",
        this.handleAddNewAddress.bind(this),
      );

      $(document).on(
        "click",
        ".btn-edit-address[data-action='change']",
        this.openSelectAddressModal.bind(this),
      );
      $(document).on(
        "click",
        "#closeModalSelectAddress",
        this.closeSelectAddressModal.bind(this),
      );
      $(document).on(
        "click",
        "#btnAddNewAddressFromSelect",
        this.openAddAddressFromSelect.bind(this),
      );
      $(document).on(
        "click",
        "#btnSelectAddress",
        this.handleSelectAddress.bind(this),
      );

      $(document).on(
        "click",
        "#btnConfirmShipping",
        this.handleConfirmShipping.bind(this),
      );

      // O submit do #btnConfirmPayment é tratado pelo form.checkout nativo
      // (WooCommerce + gateways como Pagar.me). Não interceptamos aqui.

      // Event listeners para step de seleção de endereço
      $(document).on(
        "click",
        "#btnAddNewAddressFromStep",
        this.openAddAddressFromStep.bind(this),
      );
      $(document).on(
        "click",
        "#btnConfirmSelectedAddress",
        this.handleConfirmSelectedAddress.bind(this),
      );
      $(document).on(
        "click",
        ".select-address-card",
        this.handleAddressCardClick.bind(this),
      );

      // Event listener para editar endereço no resumo
      $(document).on(
        "click",
        ".btn-edit-address-icon",
        this.openAddressSelectionModal.bind(this),
      );
      $(document).on(
        "click",
        ".step-item",
        this.handleStepIndicatorClick.bind(this),
      );

      $(document).on(
        "click",
        ".btn-back-checkout",
        this.handleBackButton.bind(this),
      );
    },

    /**
     * Mostrar step específico
     */
    showStep: function (stepId, options) {
      options = options || {};

      // Remove active de todos
      $(".auth-step").removeClass("active");

      // Adiciona active no step desejado
      $(`#${stepId}`).addClass("active");

      this.refreshStepState(stepId);

      // Sincroniza a URL da etapa. skipUrl é usado quando a mudança veio do
      // próprio histórico (popstate), evitando reescrever o que o navegador
      // acabou de restaurar. urlMode: "push" (padrão, avanço) cria entrada no
      // histórico; "replace" apenas corrige a URL atual.
      if (!options.skipUrl) {
        this.syncUrlForStep(stepId, options.urlMode || "push");
      }
    },

    refreshStepState: function (stepId) {
      switch (stepId) {
        case "authStepSelectAddress":
          this.loadAddressesForSelection();
          break;
        case "authStepShipping":
          this.loadAddressesAndCalculateShipping();
          break;
        case "authStepPayment":
          // reload direto no pagamento: se o frete ainda não foi carregado
          // (sem radio na tela e sem método em memória), o total fica em R$ 0,00.
          // recarrega o frete mantendo o método que já estava na sessão.
          if (
            $('input[name="shipping_method[0]"]').length === 0 &&
            !window.__userIntentShippingMethod &&
            !window.__lastConfirmedShippingMethod
          ) {
            this.loadAddressesAndCalculateShipping({ preserveChosen: true });
          }

          // Sincroniza observações do pedido (Step 3 → hidden do form)
          $("#order_comments_hidden").val(
            ($("#orderNotesCheckout").val() || "").trim()
          );

          this.syncBillingShippingHiddens();

          // Sincroniza hidden + radio com o intent do usuário ANTES do
          // update_checkout, pra o gateway ver o total certo.
          const intent =
            window.__userIntentShippingMethod ||
            window.__lastConfirmedShippingMethod ||
            $('input[name="shipping_method[0]"]:checked').val();
          if (intent) {
            $("#shipping_method_0").val(intent);
            const $r = $(`input[name="shipping_method[0]"][value="${intent}"]`);
            if ($r.length) {
              $('input[name="shipping_method[0]"]').prop("checked", false);
              $r.prop("checked", true);
            }
          }

          $("#paymentTotalWithShipping").text($("#totalWithShipping").text());
          $(document.body).trigger("update_checkout");
          break;
      }
    },

    getNavigationStepTarget: function (stepNumber) {
      const isLoggedIn = Boolean(
        this.userData.isRegistered ||
        $("#confirmEmail").val() ||
        $("#billing_email").val(),
      );

      switch (Number(stepNumber)) {
        case 1:
          return isLoggedIn ? "authStepConfirm" : "authStepInitial";
        case 2:
          if ($("#authStepSelectAddress").length) {
            const hasAddress =
              Boolean(this.selectedAddress) ||
              $(".select-address-card").length > 0 ||
              $("#selectedAddressSummary").children().length > 0;
            return hasAddress ? "authStepSelectAddress" : "authStepAddress";
          }
          return "authStepAddress";
        case 3:
          return "authStepShipping";
        case 4:
          return "authStepPayment";
        default:
          return null;
      }
    },

    canNavigateToStep: function (stepNumber) {
      const isLoggedIn = Boolean(
        this.userData.isRegistered ||
        $("#confirmEmail").val() ||
        $("#billing_email").val(),
      );
      const dataConfirmed =
        isLoggedIn && !$("#authStepConfirm").hasClass("active");
      const hasAddress = Boolean(this.selectedAddress);
      const hasShipping = $('input[name="shipping_method[0]"]:checked').length > 0;

      switch (Number(stepNumber)) {
        case 1:
          return true;
        case 2:
          if (!isLoggedIn) {
            this.showNotification(
              "Confirme seus dados antes de continuar.",
              "error",
            );
            return false;
          }
          return true;
        case 3:
          if (!isLoggedIn) {
            this.showNotification(
              "Confirme seus dados antes de continuar.",
              "error",
            );
            return false;
          }
          if (!hasAddress) {
            this.showNotification(
              "Adicione um endereço de entrega antes de continuar.",
              "error",
            );
            return false;
          }
          return true;
        case 4:
          if (!isLoggedIn) {
            this.showNotification(
              "Confirme seus dados antes de continuar.",
              "error",
            );
            return false;
          }
          if (!hasAddress) {
            this.showNotification(
              "Adicione um endereço de entrega antes de continuar.",
              "error",
            );
            return false;
          }
          if (!hasShipping) {
            this.showNotification(
              "Selecione um método de entrega antes de continuar.",
              "error",
            );
            return false;
          }
          return true;
        default:
          return false;
      }
    },

    handleBackButton: function (e) {
      e.preventDefault();

      const activeStepNumber = this.getCurrentActiveStepNumber();

      // Etapa 1: comportamento original — sai do checkout.
      if (activeStepNumber <= 1) {
        window.history.back();
        return;
      }

      // Se avançamos por aqui, há entradas de etapa no histórico: deixa o
      // navegador voltar uma etapa e o popstate cuida de renderizar.
      const depth =
        (window.history.state && window.history.state.__checkoutDepth) || 0;
      if (depth > 0) {
        window.history.back();
        return;
      }

      // Sem histórico de etapas (ex.: reload direto em /finalizar-compra/entrega):
      // reescreve a URL para a etapa anterior sem depender do histórico.
      const targetStep = this.getNavigationStepTarget(activeStepNumber - 1);
      if (targetStep) {
        this.showStep(targetStep, { urlMode: "replace" });
      }
    },

    handleStepIndicatorClick: function (e) {
      const $step = $(e.currentTarget);
      const stepNumber = Number($step.data("step"));
      const activeStepNumber = this.getCurrentActiveStepNumber();

      if (stepNumber >= activeStepNumber) {
        if (stepNumber > activeStepNumber) {
          this.showNotification(
            "Para avançar, use os botões do fluxo do checkout.",
            "error",
          );
        }
        return;
      }

      if (!this.canNavigateToStep(stepNumber)) {
        return;
      }

      const targetStep = this.getNavigationStepTarget(stepNumber);

      if (!targetStep || !$("#" + targetStep).length) {
        return;
      }

      this.showStep(targetStep);
    },

    /**
     * Limpar formulário
     */
    clearForm: function () {
      $("#registerFullName").val("");
      $("#registerEmail").val("");
      $("#registerPassword").val("");
      $("#registerPasswordConfirm").val("");
      $("#registerRemember").prop("checked", false);
    },

    /**
     * Máscara de telefone celular
     */
    initPhoneMask: function ($element) {
      // Se não passar elemento, usa o padrão
      if (!$element || $element.length === 0) {
        $element = $("#confirmPhone");
      }

      // Remove eventos anteriores para evitar duplicação
      $element.off("input.phonemask");

      $element.on("input.phonemask", function (e) {
        let value = $(this).val().replace(/\D/g, "");

        if (value.length > 11) {
          value = value.slice(0, 11);
        }

        if (value.length <= 10) {
          // (00) 0000-0000
          value = value.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, "($1) $2-$3");
        } else {
          // (00) 00000-0000
          value = value.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, "($1) $2-$3");
        }

        $(this).val(value);
      });
    },

    /**
     * Máscara de CEP
     */
    initCepMask: function ($element) {
      // Se não passar elemento, usa o padrão
      if (!$element || $element.length === 0) {
        $element = $("#addressCep");
      }

      // Remove eventos anteriores para evitar duplicação
      $element.off("input.cepmask");

      $element.on("input.cepmask", function (e) {
        let value = $(this).val().replace(/\D/g, "");

        if (value.length > 8) {
          value = value.slice(0, 8);
        }

        // 00000-000
        value = value.replace(/^(\d{5})(\d{0,3}).*/, "$1-$2");

        $(this).val(value);
      });
    },

    /**
     * Buscar CEP via API
     */
    initCepSearch: function ($element, prefix) {
      // Se não passar elemento, usa o padrão
      if (!$element || $element.length === 0) {
        $element = $("#addressCep");
        prefix = "address";
      }

      // Remove eventos anteriores para evitar duplicação
      $element.off("blur.cepsearch");

      $element.on("blur.cepsearch", (e) => {
        const $input = $(e.currentTarget);
        const cep = $input.val().replace(/\D/g, "");

        // Validar CEP (8 dígitos)
        if (cep.length !== 8) {
          return;
        }

        // Mostra loading
        $input.prop("disabled", true);

        // Busca na API ViaCEP
        $.ajax({
          url: `https://viacep.com.br/ws/${cep}/json/`,
          type: "GET",
          dataType: "json",
          success: (data) => {
            if (data.erro) {
              this.showNotification("CEP não encontrado!", "error");
              return;
            }

            // Preenche os campos usando o prefixo correto
            const streetId =
              prefix === "newAddress" ? "#newAddressStreet" : "#addressStreet";
            const neighborhoodId =
              prefix === "newAddress"
                ? "#newAddressNeighborhood"
                : "#addressNeighborhood";
            const cityId =
              prefix === "newAddress" ? "#newAddressCity" : "#addressCity";
            const stateId =
              prefix === "newAddress" ? "#newAddressState" : "#addressState";
            const numberId =
              prefix === "newAddress" ? "#newAddressNumber" : "#addressNumber";

            $(streetId).val(data.logradouro);
            $(neighborhoodId).val(data.bairro);
            $(cityId).val(data.localidade);
            $(stateId).val(data.uf);

            // Foca no número
            $(numberId).focus();
          },
          error: () => {
            this.showNotification(
              "Erro ao buscar CEP. Tente novamente.",
              "error",
            );
          },
          complete: () => {
            $input.prop("disabled", false);
          },
        });
      });
    },

    /**
     * Mostrar notificação (substitui alert)
     */
    showNotification: function (message, type = "error") {
      // Remove notificações anteriores
      $(".checkout-toast").remove();

      // Cria notificação
      const toast = $(`
        <div class="checkout-toast checkout-toast-${type}">
          <div class="toast-icon">
            ${
              type === "error"
                ? '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="currentColor" stroke-width="2"/><path d="M10 6V10" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M10 14H10.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>'
                : '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z" stroke="currentColor" stroke-width="2"/><path d="M7 10L9 12L13 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
            }
          </div>
          <div class="toast-message">${message}</div>
          <button class="toast-close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      `);

      $("body").append(toast);

      // Anima entrada
      setTimeout(() => toast.addClass("show"), 10);

      // Auto-remove após 5s
      const timer = setTimeout(() => {
        toast.removeClass("show");
        setTimeout(() => toast.remove(), 300);
      }, 5000);

      // Botão fechar
      toast.find(".toast-close").on("click", function () {
        clearTimeout(timer);
        toast.removeClass("show");
        setTimeout(() => toast.remove(), 300);
      });
    },

    /**
     * Toggle visibilidade senha
     */
    togglePassword: function (e) {
      e.preventDefault();
      const targetId = $(this).data("target");
      const $input = $(`#${targetId}`);
      const type = $input.attr("type");

      $input.attr("type", type === "password" ? "text" : "password");
    },

    /**
     * Handle cadastro
     */
    handleRegister: function (e) {
      e.preventDefault();

      const $form = $("#formRegisterCheckout");
      const $btn = $("#btnRegisterSubmit");

      // Validação de senhas
      const password = $("#registerPassword").val();
      const passwordConfirm = $("#registerPasswordConfirm").val();

      if (password !== passwordConfirm) {
        this.showNotification("As senhas não conferem!", "error");
        return;
      }

      if (password.length < 6) {
        this.showNotification(
          "A senha deve ter no mínimo 6 caracteres!",
          "error",
        );
        return;
      }

      // Salva dados temporários
      this.userData.fullName = $("#registerFullName").val();
      this.userData.email = $("#registerEmail").val();
      this.userData.password = password;

      // Loading state
      $btn.prop("disabled", true).text("Cadastrando...");

      // AJAX para registrar usuário
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        data: {
          action: "checkout_register_user",
          nonce: checkoutCartParams.nonce,
          full_name: this.userData.fullName,
          email: this.userData.email,
          password: this.userData.password,
          remember: $("#registerRemember").is(":checked"),
        },
        success: (response) => {
          if (response.success) {
            if (response.data.new_nonce) {
              checkoutCartParams.nonce = response.data.new_nonce;
            }

            // Atualiza nonces do WooCommerce nativo (evita 403 em update_order_review
            // após o login/registro mudar o user_id na sessão)
            if (typeof wc_checkout_params !== "undefined") {
              if (response.data.wc_update_order_review_nonce) {
                wc_checkout_params.update_order_review_nonce =
                  response.data.wc_update_order_review_nonce;
              }
              if (response.data.wc_process_checkout_nonce) {
                wc_checkout_params.process_checkout_nonce =
                  response.data.wc_process_checkout_nonce;
              }
            }

            this.userData.isRegistered = true;

            if (response.data.cart) {
              const cart = response.data.cart;
              if (cart.subtotal) {
                $(".checkout-cart-subtotal .subtotal-value").html(cart.subtotal);
              }
              if (cart.total) {
                $(".checkout-cart-total .total-value").html(cart.total);
              }
              let $discount = $(".checkout-cart-discount");
              if (cart.has_discount && cart.discount) {
                if (!$discount.length) {
                  $discount = $('<div class="checkout-cart-discount"><span class="discount-label">Desconto</span><span class="discount-value"></span></div>');
                  $(".checkout-cart-coupons-applied").after($discount);
                }
                $discount.find(".discount-value").html("-" + cart.discount);
                $discount.show();
              } else {
                $discount.hide();
              }
            }

            // Mostra step de confirmação
            this.showConfirmDataStep();
          } else {
            this.showNotification(
              response?.data?.message || "Erro ao cadastrar usuário",
              "error",
            );
          }
        },
        error: (xhr) => {
          const message =
            xhr.responseJSON?.data?.message ||
            "Erro ao cadastrar usuário. Tente novamente.";
          this.showNotification(message, "error");
        },
        complete: () => {
          $btn.prop("disabled", false).text("CADASTRAR");
        },
      });
    },

    /**
     * Handle login
     */
    handleLogin: function (e) {
      e.preventDefault();

      const $form = $("#formLoginCheckout");
      const $btn = $("#btnLoginSubmit");
      const email = $("#loginEmail").val();
      const password = $("#loginPassword").val();
      const remember = $("#loginRemember").is(":checked");

      // Loading state
      $btn.prop("disabled", true).text("Entrando...");

      // AJAX para fazer login
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        data: {
          action: "checkout_login_user",
          nonce: checkoutCartParams.nonce,
          email: email,
          password: password,
          remember: remember,
        },
        success: (response) => {
          if (response.success) {
            // Recarrega a página para mostrar checkout logado
            window.location.reload();
          } else {
            this.showNotification(
              response?.data?.message || "Erro ao fazer login",
              "error",
            );
          }
        },
        error: (xhr) => {
          const message =
            xhr.responseJSON?.data?.message ||
            "Erro ao fazer login. Tente novamente.";
          this.showNotification(message, "error");
        },
        complete: () => {
          $btn.prop("disabled", false).text("ENTRAR");
        },
      });
    },

    /**
     * Mostrar step de confirmação de dados
     */
    showConfirmDataStep: function () {
      // Preenche dados na confirmação
      $("#confirmUserName").text(this.userData.fullName.split(" ")[0]);
      $("#confirmName").val(this.userData.fullName);
      $("#confirmEmail").val(this.userData.email);
      $("#billing_email").val(this.userData.email).trigger('change');
      $("#confirmPhone").val(this.userData.phone || "");
      $("#confirmCpf").val(this.userData.cpf || "");
      $("#confirmBirthdate").val(this.formatBirthdate(this.userData.birthdate || ""));

      // Ativa máscara de CPF
      this.initCpfMask($("#confirmCpf"));

      // Ativa máscara de data de nascimento
      this.initBirthdateMask($("#confirmBirthdate"));

      // Se CPF já existe, deixa readonly; senão editável
      $("#confirmCpf").attr("readonly", false);

      // Se já tem data de nascimento, readonly (editável via lápis); senão, aberto
      if (this.userData.birthdate) {
        $("#confirmBirthdate").attr("readonly", true);
      } else {
        $("#confirmBirthdate").attr("readonly", false);
      }

      // Mostra step
      this.showStep("authStepConfirm");
    },

    /**
     * Máscara de CPF: 000.000.000-00
     */
    formatCpf: function (value) {
      value = (value || "").replace(/\D/g, "").slice(0, 11);
      return value
        .replace(/^(\d{3})(\d)/, "$1.$2")
        .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
        .replace(/\.(\d{3})(\d{1,2})$/, ".$1-$2");
    },

    initCpfMask: function ($element) {
      if (!$element || $element.length === 0) {
        $element = $("#confirmCpf");
      }
      $element.val(this.formatCpf($element.val()));
      $element.off("input.cpfmask");
      $element.on("input.cpfmask", function () {
        $(this).val(CheckoutAuth.formatCpf($(this).val()));
      });
    },

    formatBirthdate: function (value) {
      value = (value || "").replace(/\D/g, "").slice(0, 8);
      return value
        .replace(/^(\d{2})(\d)/, "$1/$2")
        .replace(/^(\d{2})\/(\d{2})(\d)/, "$1/$2/$3");
    },

    initBirthdateMask: function ($element) {
      if ($element && $element.length > 0) {
        // Elemento específico passado — aplica diretamente
        $element.val(this.formatBirthdate($element.val()));
        $element.off("input.birthdatemask");
        $element.on("input.birthdatemask", function () {
          $(this).val(CheckoutAuth.formatBirthdate($(this).val()));
        });
      } else {
        // Delegação global — cobre qualquer #confirmBirthdate que apareça no DOM
        $(document).off("input.birthdatemask", "#confirmBirthdate");
        $(document).on("input.birthdatemask", "#confirmBirthdate", function () {
          $(this).val(CheckoutAuth.formatBirthdate($(this).val()));
        });
      }
    },

    isValidBirthdate: function (value) {
      const clean = (value || "").replace(/\D/g, "");
      if (clean.length !== 8) return false;
      const day = parseInt(clean.slice(0, 2), 10);
      const month = parseInt(clean.slice(2, 4), 10);
      const year = parseInt(clean.slice(4, 8), 10);
      if (month < 1 || month > 12) return false;
      if (day < 1 || day > 31) return false;
      const currentYear = new Date().getFullYear();
      if (year < 1900 || year > currentYear) return false;
      return true;
    },

    /**
     * Valida CPF (11 dígitos + dígitos verificadores)
     */
    isValidCpf: function (cpf) {
      cpf = (cpf || "").replace(/\D/g, "");
      if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;
      let sum = 0;
      for (let i = 0; i < 9; i++) sum += parseInt(cpf.charAt(i)) * (10 - i);
      let d1 = 11 - (sum % 11);
      if (d1 >= 10) d1 = 0;
      if (d1 !== parseInt(cpf.charAt(9))) return false;
      sum = 0;
      for (let i = 0; i < 10; i++) sum += parseInt(cpf.charAt(i)) * (11 - i);
      let d2 = 11 - (sum % 11);
      if (d2 >= 10) d2 = 0;
      return d2 === parseInt(cpf.charAt(10));
    },

    /**
     * Editar dados na confirmação
     */
    handleEditData: function (e) {
      e.preventDefault();
      const field = $(e.currentTarget).data("field");
      const $input = $(
        `#confirm${field.charAt(0).toUpperCase() + field.slice(1)}`,
      );

      if ($input.attr("readonly")) {
        // Habilita edição
        $input.attr("readonly", false).focus();
        $(e.currentTarget).addClass("editing");
      } else {
        // Salva edição
        $input.attr("readonly", true);
        $(e.currentTarget).removeClass("editing");

        // Atualiza userData
        if (field === "name") {
          this.userData.fullName = $input.val();
        } else if (field === "email") {
          this.userData.email = $input.val();
        } else if (field === "phone") {
          this.userData.phone = $input.val();
        } else if (field === "cpf") {
          this.userData.cpf = $input.val();
        } else if (field === "birthdate") {
          this.userData.birthdate = $input.val();
        }
      }
    },

    /**
     * Confirmar dados e adicionar telefone
     */
    handleConfirmData: function (e) {
      e.preventDefault();

      const $btn = $("#btnConfirmData");
      const name = $("#confirmName").val();
      const email = $("#confirmEmail").val();
      const phone = $("#confirmPhone").val();
      const cpf = $("#confirmCpf").val();
      const birthdate = $("#confirmBirthdate").val();

      // Remove formatação para validar
      const phoneClean = phone.replace(/\D/g, "");

      if (!phoneClean || phoneClean.length < 10) {
        this.showNotification(
          "Por favor, preencha o telefone corretamente!",
          "error",
        );
        $("#confirmPhone").focus();
        return;
      }

      if (!this.isValidCpf(cpf)) {
        this.showNotification("Por favor, informe um CPF válido!", "error");
        $("#confirmCpf").attr("readonly", false).focus();
        return;
      }

      if (!this.isValidBirthdate(birthdate)) {
        this.showNotification(
          "Por favor, informe uma data de nascimento válida (DD/MM/AAAA)!",
          "error",
        );
        $("#confirmBirthdate").focus();
        return;
      }

      // Atualiza dados
      this.userData.fullName = name;
      this.userData.email = email;
      this.userData.phone = phone;
      this.userData.cpf = cpf;
      this.userData.birthdate = birthdate;

      // Loading state
      $btn.prop("disabled", true).text("Confirmando...");

      // AJAX para atualizar dados do usuário (nome, email, telefone e cpf)
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "checkout_update_user_data",
          nonce: checkoutCartParams.nonce,
          name: this.userData.fullName,
          email: this.userData.email,
          phone: this.userData.phone,
          cpf: this.userData.cpf,
          birthdate: this.userData.birthdate,
        },
        success: (response) => {
          if (response.success) {
            // Usa a variável nextStepAfterConfirm para saber para onde ir
            const nextStep = this.nextStepAfterConfirm || "authStepAddress";
            this.showStep(nextStep);

            this.showNotification("Dados confirmados!", "success");
          } else {
            const errorMessage =
              response.data?.message ||
              response.message ||
              "Erro ao atualizar dados";
            this.showNotification(errorMessage, "error");
          }
        },
        error: (xhr) => {
          const message =
            xhr.responseJSON?.data?.message ||
            "Erro ao atualizar dados. Tente novamente.";
          this.showNotification(message, "error");
        },
        complete: () => {
          $btn.prop("disabled", false).text("CONFIRMAR");
        },
      });
    },

    /**
     * Salvar endereço
     */
    handleSaveAddress: function (e) {
      e.preventDefault();

      const $form = $("#formAddressCheckout");
      const $btn = $("#btnAddressSubmit");

      // Captura dados do formulário
      const formData = {
        action: "checkout_save_address",
        nonce: checkoutCartParams.nonce,
        cep: $("#addressCep").val(),
        address: $("#addressStreet").val(),
        number: $("#addressNumber").val(),
        complement: $("#addressComplement").val(),
        neighborhood: $("#addressNeighborhood").val(),
        city: $("#addressCity").val(),
        state: $("#addressState").val(),
        instructions: $("#addressInstructions").val(),
      };

      // Validações básicas
      if (
        !formData.cep ||
        !formData.address ||
        !formData.number ||
        !formData.neighborhood ||
        !formData.city ||
        !formData.state
      ) {
        this.showNotification(
          "Preencha todos os campos obrigatórios!",
          "error",
        );
        return;
      }

      // Loading state
      $btn.prop("disabled", true).text("Salvando...");

      // AJAX para salvar endereço
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: formData,
        success: (response) => {
          if (response.success) {
            this.showNotification("Endereço salvo com sucesso!", "success");

            // Se veio do step de seleção, volta para lá
            // Senão, vai direto para shipping
            if (this.cameFromSelectAddress) {
              this.showStep("authStepSelectAddress");
              this.cameFromSelectAddress = false;
            } else {
              this.showStep("authStepShipping");
              this.loadAddressesAndCalculateShipping();
            }
          } else {
            this.showNotification(
              response.data.message || "Erro ao salvar endereço",
              "error",
            );
          }
        },
        error: (xhr) => {
          const message =
            xhr.responseJSON?.data?.message ||
            "Erro ao salvar endereço. Tente novamente.";
          this.showNotification(message, "error");
        },
        complete: () => {
          $btn.prop("disabled", false).text("ADICIONAR");
        },
      });
    },

    /**
     * Abre modal de adicionar endereço
     */
    setupAddAddressModalScrollFallback: function () {
      const modalEl = document.getElementById("modalAddAddress");
      if (!modalEl || this.addAddressModalWheelHandler) {
        return;
      }

      this.addAddressModalElement = modalEl;
      this.addAddressModalWheelHandler = (e) => {
        const modalBody = modalEl.querySelector(".modal-body");
        if (!modalBody || !modalEl.classList.contains("active")) {
          return;
        }

        const interactiveTarget = e.target.closest(
          "textarea, select, [contenteditable='true']",
        );
        if (interactiveTarget) {
          e.stopPropagation();
          return;
        }

        if (modalBody.scrollHeight <= modalBody.clientHeight) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        modalBody.scrollTop += e.deltaY;
      };

      modalEl.addEventListener("wheel", this.addAddressModalWheelHandler, {
        passive: false,
        capture: true,
      });
    },

    pauseSmoothScroll: function () {
      if (window.lenis) {
        window.lenis.stop();
      }
    },

    resumeSmoothScroll: function () {
      if (window.lenis) {
        window.lenis.start();
      }
    },

    openAddAddressModal: function () {
      this.setupAddAddressModalScrollFallback();
      $("#modalAddAddress").show().addClass("active");
      $("body").addClass("modal-open");
      this.pauseSmoothScroll();
      this.initCepMask($("#newAddressCep"));
      this.initCepSearch($("#newAddressCep"), "newAddress");
      this.initPhoneMask($("#newAddressRecipientPhone"));
    },

    /**
     * Fecha modal de adicionar endereço
     */
    closeAddAddressModal: function () {
      $("#modalAddAddress").removeClass("active").hide();
      $("#formAddNewAddress")[0].reset();
      $("body").removeClass("modal-open");
      this.resumeSmoothScroll();
    },

    /**
     * Abre modal de selecionar endereço
     */
    openSelectAddressModal: function () {
      // Mostra o botão de adicionar novo endereço por padrão
      $("#btnAddNewAddressFromSelect").show();
      $("#modalSelectAddress").show().addClass("active");
      $("body").addClass("modal-open");
      this.pauseSmoothScroll();
      this.loadAddresses();
    },

    /**
     * Abre modal de seleção de endereço a partir do ícone de editar no resumo
     */
    openAddressSelectionModal: function () {
      // Oculta o botão de adicionar novo endereço quando vem do resumo
      $("#btnAddNewAddressFromSelect").hide();
      // Mostra o modal e carrega endereços (sem chamar openSelectAddressModal que mostra o botão)
      $("#modalSelectAddress").show().addClass("active");
      $("body").addClass("modal-open");
      this.pauseSmoothScroll();
      this.loadAddresses();
    },

    /**
     * Fecha modal de selecionar endereço
     */
    closeSelectAddressModal: function () {
      $("#modalSelectAddress").removeClass("active").hide();
      $("body").removeClass("modal-open");
      this.resumeSmoothScroll();
      // Se veio do shipping, recarrega os endereços para atualizar
      if ($("#authStepShipping").hasClass("active")) {
        this.loadAddresses();
      }
    },

    /**
     * Abre modal de adicionar do modal de seleção
     */
    openAddAddressFromSelect: function () {
      this.closeSelectAddressModal();
      this.openAddAddressModal();
    },

    /**
     * Fecha todos os modais
     */
    closeAllModals: function (e) {
      if ($(e.target).hasClass("modal-overlay")) {
        $(".checkout-modal").removeClass("active").hide();
        $("body").removeClass("modal-open");
        this.resumeSmoothScroll();
      }
    },

    /**
     * Adicionar novo endereço
     */
    handleAddNewAddress: function (e) {
      e.preventDefault();

      const $form = $("#formAddNewAddress");
      const $btn = $("#btnSaveNewAddress");

      // Coleta dados
      const formData = {
        action: "add_new_address",
        nonce: checkoutCartParams.nonce,
        recipient_name: $("#newAddressRecipientName").val(),
        recipient_phone: $("#newAddressRecipientPhone").val(),
        cep: $("#newAddressCep").val(),
        address: $("#newAddressStreet").val(),
        number: $("#newAddressNumber").val(),
        complement: $("#newAddressComplement").val(),
        neighborhood: $("#newAddressNeighborhood").val(),
        city: $("#newAddressCity").val(),
        state: $("#newAddressState").val(),
        instructions: $("#newAddressInstructions").val(),
        set_default: $("#newAddressSetDefault").is(":checked"),
      };

      // Validações
      if (
        !formData.cep ||
        !formData.address ||
        !formData.number ||
        !formData.neighborhood ||
        !formData.city ||
        !formData.state
      ) {
        this.showNotification(
          "Preencha todos os campos obrigatórios!",
          "error",
        );
        return;
      }

      // Loading
      $btn.prop("disabled", true).text("Salvando...");

      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: formData,
        success: (response) => {
          if (response.success) {
            this.showNotification(
              "Endereço adicionado com sucesso!",
              "success",
            );
            this.closeAddAddressModal();

            // Se veio do step de seleção, recarrega a lista
            if (this.cameFromSelectAddress) {
              this.loadAddressesForSelection();
              this.cameFromSelectAddress = false;
            }
            // Se veio do shipping, recarrega o resumo de endereço
            else if (this.cameFromShipping) {
              setTimeout(() => {
                this.loadAddresses();
                this.calculateShipping();
              }, 300);
              this.cameFromShipping = false;
            }
            // Se está no step de endereço (cadastro), recarrega endereços e recalcula frete
            else {
              this.loadAddresses();
              this.calculateShipping();
            }
          } else {
            this.showNotification(
              response.data.message || "Erro ao adicionar endereço",
              "error",
            );
          }
        },
        error: (xhr) => {
          const message =
            xhr.responseJSON?.data?.message ||
            "Erro ao adicionar endereço. Tente novamente.";
          this.showNotification(message, "error");
        },
        complete: () => {
          $btn.prop("disabled", false).text("SALVAR");
        },
      });
    },

    /**
     * Abre modal de adicionar endereço a partir do shipping
     */
    handleAddNewAddressFromShipping: function () {
      this.cameFromShipping = true;
      this.openAddAddressModal();
      // Marca o checkbox de tornar padrão automaticamente
      setTimeout(() => {
        $("#newAddressSetDefault").prop("checked", true);
      }, 100);
    },

    /**
     * Selecionar endereço
     */
    handleSelectAddress: function () {
      const selectedIndex = $('input[name="selected_address"]:checked').val();

      if (selectedIndex === undefined) {
        this.showNotification("Selecione um endereço", "error");
        return;
      }

      // Busca o endereço selecionado e atualiza
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "set_selected_address",
          nonce: checkoutCartParams.nonce,
          address_index: selectedIndex,
        },
        success: (response) => {
          if (response.success) {
            // Recarrega endereços do servidor para pegar o novo endereço
            // padrão e dispara o recálculo de frete em cima desse endereço.
            // (Antes esse fluxo usava response.data.address, que o backend
            // não retorna — o frete acabava sendo recalculado com o CEP antigo.)
            this.loadAddressesAndCalculateShipping();
            this.closeSelectAddressModal();
            this.showNotification("Endereço atualizado!", "success");
          }
        },
      });
    },

    /**
     * Confirmar método de entrega
     */
    handleConfirmShipping: function () {
      // Prioridade: intent do usuário (último clique humano) > radio :checked
      // > último confirmado pelo backend. O :checked pode ter sido revertido
      // por algum hook silencioso entre o clique e o "Confirmar".
      const userIntent = window.__userIntentShippingMethod;
      const checkedMethod = $('input[name="shipping_method[0]"]:checked').val();
      const lastConfirmed = window.__lastConfirmedShippingMethod;
      const selectedMethod = userIntent || checkedMethod || lastConfirmed;

      if (!selectedMethod) {
        this.showNotification("Selecione um método de entrega", "error");
        return;
      }

      // Garante que o radio reflete a escolha antes de submeter — assim
      // o WC vê o radio certo no update_checkout que vem em seguida.
      const $target = $(
        `input[name="shipping_method[0]"][value="${selectedMethod}"]`,
      );
      if ($target.length) {
        $('input[name="shipping_method[0]"]').prop("checked", false);
        $target.prop("checked", true);
        $("#shipping_method_0").val(selectedMethod);
      }

      // ===== VALIDAÇÃO OBRIGATÓRIA: Data de entrega =====
      const deliveryDate = $("#e_deliverydate_0").val();
      const isLocalPickup = selectedMethod.indexOf("local_pickup") === 0;

      if (!isLocalPickup && (!deliveryDate || deliveryDate.trim() === "")) {
        this.showNotification(
          "Por favor, selecione uma data de entrega antes de continuar",
          "error",
        );
        return;
      }

      // Salva método selecionado e vai para próximo passo (pagamento)
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "save_shipping_method",
          nonce: checkoutCartParams.nonce,
          shipping_method: selectedMethod,
        },
        success: (response) => {
          if (response.success) {
            this.showNotification("Método de entrega confirmado!", "success");

            // Sincroniza o input hidden do form de pagamento já com o método
            // escolhido — o WC_AJAX::update_order_review() lê esse valor para
            // recalcular os totais (incluindo o frete) antes de re-renderizar
            // os payment_fields dos gateways (parcelas, PIX, etc.).
            $("#shipping_method_0").val(selectedMethod);

            // Dispara update_checkout uma vez para o Woo recalcular tudo;
            // só então abre a step de pagamento, com o #order_review já novo.
            $(document.body)
              .off("updated_checkout.payment_step")
              .one("updated_checkout.payment_step", () => {
                this.goToPaymentStep();
              });
            $(document.body).trigger("update_checkout");
          }
        },
        error: (xhr) => {
          console.error(
            "[CHECKOUT-DEBUG] save_shipping_method ERROR:",
            xhr.responseText,
          );
        },
      });
    },

    /**
     * Navega para o step de pagamento
     */
    goToPaymentStep: function () {
      this.showStep("authStepPayment");
    },

    /**
     * Atualiza os hidden inputs de billing/shipping dentro do form.checkout
     * com base no endereco selecionado. Garante que WC_Checkout::process_checkout
     * receba todos os campos obrigatorios.
     */
    syncBillingShippingHiddens: function () {
      // Email: o WC_Checkout::process_checkout exige billing_email e o campo
      // vem vazio do servidor quando o usuário se cadastra durante o checkout.
      // Não depende do endereço, então sincroniza antes do return abaixo.
      const email = this.userData.email || $("#confirmEmail").val() || "";
      if (email) {
        $("#billing_email").val(email);
      }

      const addr = this.selectedAddress;
      if (!addr) return;

      const map = {
        billing_postcode: addr.cep,
        billing_address_1: addr.address,
        billing_address_2: addr.complement,
        billing_number: addr.number,
        billing_district: addr.neighborhood || addr.district,
        billing_city: addr.city,
        billing_state: addr.state,
        shipping_postcode: addr.cep,
        shipping_address_1: addr.address,
        shipping_address_2: addr.complement,
        shipping_number: addr.number,
        shipping_district: addr.neighborhood || addr.district,
        shipping_city: addr.city,
        shipping_state: addr.state,
      };

      Object.keys(map).forEach((id) => {
        const value = map[id] == null ? "" : map[id];
        const $el = $("#" + id);
        if ($el.length) $el.val(value);
      });

      // Telefone: prioriza o do destinatário do endereço; senão usa o do cadastro.
      const phone = addr.recipient_phone || this.userData.phone || "";
      if (phone) {
        $("#billing_phone").val(phone);
      }

      // Nome: prioriza o do destinatário do endereço; senão usa o do cadastro.
      const nameSource = addr.recipient_name || this.userData.fullName || "";
      if (nameSource) {
        const parts = String(nameSource).trim().split(/\s+/);
        const first = parts.shift() || "";
        const last = parts.join(" ") || first;
        if (first) {
          $("#billing_first_name").val(first);
          $("#shipping_first_name").val(first);
          $("#billing_last_name").val(last);
          $("#shipping_last_name").val(last);
        }
      }

      // CPF: sincroniza com billing_cpf/billing_document/shipping_document
      const cpf = this.userData.cpf || "";
      if (cpf) {
        $("#billing_cpf").val(cpf);
        $("#billing_document").val(cpf);
        $("#shipping_document").val(cpf);
        $("#billing_persontype").val("1");
      }

      // Método de entrega selecionado no authStepShipping
      const selectedShipping = $('input[name="shipping_method[0]"]:checked').val();
      if (selectedShipping) {
        $("#shipping_method_0").val(selectedShipping);
      }

      // Campos de agendamento de entrega (Order Delivery Date plugin)
      const eDate =
        $("#e_deliverydate_0").not("#e_deliverydate_0_hidden").val() || "";
      const hDate =
        $("#h_deliverydate_0").not("#h_deliverydate_0_hidden").val() || "";
      const timeSlot =
        $("#orddd_time_slot_0").not("#orddd_time_slot_0_hidden").val() || "";
      $("#e_deliverydate_0_hidden").val(eDate);
      $("#h_deliverydate_0_hidden").val(hDate);
      $("#orddd_time_slot_0_hidden").val(timeSlot);
    },

    /**
     * Carrega métodos de pagamento disponíveis
     */
    loadPaymentMethods: function () {
      const $list = $("#paymentMethodsList");
      $list.html(
        '<div class="loading-payment">Carregando métodos de pagamento...</div>',
      );

      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "get_payment_methods",
          nonce: checkoutCartParams.nonce,
        },
        success: (response) => {
          if (response.success && response.data.methods) {
            this.displayPaymentMethods(response.data.methods);
          } else {
            $list.html(
              '<div class="error-payment">Erro ao carregar métodos de pagamento.</div>',
            );
          }
        },
        error: () => {
          $list.html(
            '<div class="error-payment">Erro ao carregar métodos de pagamento.</div>',
          );
        },
      });
    },

    /**
     * Exibe métodos de pagamento na tela
     */
    displayPaymentMethods: function (methods) {
      const $list = $("#paymentMethodsList");
      $list.empty();

      methods.forEach((method, index) => {
        const isChecked = index === 0 ? "checked" : "";

        const methodHtml = `
          <label class="payment-method-card">
            <input type="radio" name="payment_method" value="${method.id}" ${isChecked}>
            <div class="payment-method-content">
              <div class="payment-method-icon">
                ${this.getPaymentIcon(method.id)}
              </div>
              <div class="payment-method-name">${method.title}</div>
            </div>
            <div class="payment-method-radio"></div>
          </label>
        `;

        $list.append(methodHtml);
      });
    },

    /**
     * Retorna ícone SVG para o método de pagamento
     */
    getPaymentIcon: function (methodId) {
      const icons = {
        bacs: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M3,6H21V18H3V6M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9M7,8A2,2 0 0,1 5,10V14A2,2 0 0,1 7,16H17A2,2 0 0,1 19,14V10A2,2 0 0,1 17,8H7Z"/></svg>',
        pix: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7.07,18.28C7.5,17.38 10.12,16.5 12,16.5C13.88,16.5 16.5,17.38 16.93,18.28C15.57,19.36 13.86,20 12,20C10.14,20 8.43,19.36 7.07,18.28M18.36,16.83C16.93,15.09 13.46,14.5 12,14.5C10.54,14.5 7.07,15.09 5.64,16.83C4.62,15.5 4,13.82 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,13.82 19.38,15.5 18.36,16.83M12,6C10.06,6 8.5,7.56 8.5,9.5C8.5,11.44 10.06,13 12,13C13.94,13 15.5,11.44 15.5,9.5C15.5,7.56 13.94,6 12,6M12,11A1.5,1.5 0 0,1 10.5,9.5A1.5,1.5 0 0,1 12,8A1.5,1.5 0 0,1 13.5,9.5A1.5,1.5 0 0,1 12,11Z"/></svg>',
        cod: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20,18H4V6H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4M11,17H13V16H14A1,1 0 0,0 15,15V12A1,1 0 0,0 14,11H11V10H15V8H13V7H11V8H10A1,1 0 0,0 9,9V12A1,1 0 0,0 10,13H13V14H9V16H11V17Z"/></svg>',
      };

      return (
        icons[methodId] ||
        '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"/></svg>'
      );
    },

    /**
     * Confirmar método de pagamento e finalizar pedido
     */
    handleConfirmPayment: function () {
      const selectedPayment = $('input[name="payment_method"]:checked').val();

      if (!selectedPayment) {
        this.showNotification("Selecione um método de pagamento", "error");
        return;
      }

      const $btn = $("#btnConfirmPayment");
      $btn.prop("disabled", true).text("Processando...");

      // ===== NOVO: Captura data e horário de entrega =====
      // O plugin Order Delivery Date usa campos específicos:
      // - e_deliverydate_0: Data formatada para exibição
      // - h_deliverydate_0: Data em formato oculto (para processamento)
      // - orddd_time_slot_0: Slot de horário selecionado

      let deliveryDateDisplay = "";
      let deliveryDateHidden = "";
      let deliveryTimeSlot = "";

      // Captura data de entrega (formato de exibição)
      const $dateInputDisplay = $(
        'input[name="e_deliverydate_0"], input#e_deliverydate_0',
      );
      if ($dateInputDisplay.length && $dateInputDisplay.val()) {
        deliveryDateDisplay = $dateInputDisplay.val();
      }

      // Captura data de entrega (formato oculto)
      const $dateInputHidden = $(
        'input[name="h_deliverydate_0"], input#h_deliverydate_0',
      );
      if ($dateInputHidden.length && $dateInputHidden.val()) {
        deliveryDateHidden = $dateInputHidden.val();
      }

      // Captura horário de entrega
      const $timeSlot = $(
        'select[name="orddd_time_slot_0"], select#orddd_time_slot_0',
      );
      if ($timeSlot.length && $timeSlot.val()) {
        deliveryTimeSlot = $timeSlot.val();
      }

      // Prepara dados para envio
      const selectedShippingMethod =
        $('input[name="shipping_method[0]"]:checked').val() ||
        $("#shipping_method_0").val() ||
        "";

      const requestData = {
        action: "process_checkout_order",
        nonce: checkoutCartParams.nonce,
        payment_method: selectedPayment,
        shipping_method: selectedShippingMethod,
      };

      // Adiciona campos do Order Delivery Date Plugin exatamente como ele espera
      if (deliveryDateDisplay) {
        requestData.e_deliverydate_0 = deliveryDateDisplay;
      }

      if (deliveryDateHidden) {
        requestData.h_deliverydate_0 = deliveryDateHidden;
      }

      if (deliveryTimeSlot) {
        requestData.orddd_time_slot_0 = deliveryTimeSlot;
      }

      // Salva método de pagamento e finaliza pedido
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: requestData,
        success: (response) => {
          if (response.success) {
            this.showNotification("Pedido realizado com sucesso!", "success");

            // Redireciona para página de confirmação/agradecimento
            if (response.data.redirect_url) {
              window.location.href = response.data.redirect_url;
            }
          } else {
            this.showNotification(
              response.data.message || "Erro ao processar pedido",
              "error",
            );
            $btn.prop("disabled", false).text("FINALIZAR PEDIDO");
          }
        },
        error: () => {
          this.showNotification("Erro ao processar pedido", "error");
          $btn.prop("disabled", false).text("FINALIZAR PEDIDO");
        },
      });
    },

    /**
     * Carrega endereços para a tela de seleção
     */
    loadAddressesForSelection: function () {
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "get_user_addresses",
          nonce: checkoutCartParams.nonce,
        },
        success: (response) => {
          if (response.success && response.data.addresses) {
            this.displayAddressesForSelection(response.data.addresses);
          }
        },
      });
    },

    /**
     * Exibe endereços na tela de seleção
     */
    displayAddressesForSelection: function (addresses) {
      const $list = $("#selectAddressesList");
      $list.empty();

      addresses.forEach((address, index) => {
        const isDefault = address.is_default || index === 0;
        const badgeHtml = isDefault
          ? '<div class="address-badge">Padrão</div>'
          : "";

        const cardHtml = `
          <div class="select-address-card ${isDefault ? "selected" : ""}" data-index="${index}">
            <input type="radio" name="select_address" value="${index}" ${isDefault ? "checked" : ""}>
            ${badgeHtml}
            <div class="address-recipient">${address.recipient_name || ""} | ${address.recipient_phone || ""}</div>
            <div class="address-street">${address.address}, ${address.number}${address.complement ? " - " + address.complement : ""}</div>
            <div class="address-city">${address.city}/${address.state} - ${address.cep}</div>
            ${address.instructions ? `<div class="address-instructions">Instruções de entrega: ${address.instructions}</div>` : ""}
          </div>
        `;

        $list.append(cardHtml);
      });
    },

    /**
     * Handle click no card de endereço
     */
    handleAddressCardClick: function (e) {
      const $card = $(e.currentTarget);
      const $radio = $card.find('input[type="radio"]');

      // Remove selected de todos
      $(".select-address-card").removeClass("selected");

      // Adiciona selected no clicado
      $card.addClass("selected");

      // Marca o radio
      $radio.prop("checked", true);
    },

    /**
     * Abre formulário de adicionar endereço a partir do step de seleção
     */
    openAddAddressFromStep: function () {
      this.cameFromSelectAddress = true;
      this.openAddAddressModal();
    },

    /**
     * Confirma endereço selecionado e vai para shipping
     */
    handleConfirmSelectedAddress: function () {
      const selectedIndex = $('input[name="select_address"]:checked').val();
      const $btn = $("#btnConfirmSelectedAddress");

      if (selectedIndex === undefined) {
        this.showNotification("Selecione um endereço", "error");
        return;
      }

      // Loading state
      $btn.prop("disabled", true).text("Confirmando...");

      // Limpa estado de frete do endereço anterior para que displayShippingMethods
      // reaplique a auto-seleção (frete grátis se existir, senão primeiro método)
      // na nova zona. Sem isso o método antigo "preso" impede o auto-select.
      window.__userIntentShippingMethod = null;
      window.__lastConfirmedShippingMethod = null;
      $("#shipping_method_0").val("");
      $('input[name="shipping_method[0]"]').prop("checked", false);

      // Define como endereço ativo e vai para shipping
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "set_selected_address",
          nonce: checkoutCartParams.nonce,
          address_index: selectedIndex,
        },
        success: (response) => {
          if (response.success) {
            this.showNotification("Endereço confirmado!", "success");
            setTimeout(() => {
              this.showStep("authStepShipping");
              // Carrega endereços e depois calcula o frete
              this.loadAddressesAndCalculateShipping();
            }, 500);
          } else {
            this.showNotification(
              response.data.message || "Erro ao selecionar endereço",
              "error",
            );
          }
        },
        error: (xhr) => {
          const message =
            xhr.responseJSON?.data?.message ||
            "Erro ao selecionar endereço. Tente novamente.";
          this.showNotification(message, "error");
        },
        complete: () => {
          $btn.prop("disabled", false).text("CONFIRMAR");
        },
      });
    },

    /**
     * Carrega endereços do usuário
     */
    loadAddresses: function () {
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "get_user_addresses",
          nonce: checkoutCartParams.nonce,
        },
        success: (response) => {
          if (response.success && response.data.addresses) {
            this.displayAddresses(response.data.addresses);
            this.displaySelectedAddress(response.data.default_address);
          }
        },
      });
    },

    /**
     * Carrega endereços e depois calcula o frete
     */
    loadAddressesAndCalculateShipping: function (opts) {
      opts = opts || {};

      // Guard contra chamadas duplicadas em curto intervalo. Sem isso, o
      // step Entrega renderiza a lista 2x (dois calls disparados quase juntos),
      // o que reseta o radio para o primeiro item após o usuário ter clicado.
      const now = Date.now();
      if (this._lastLoadAddressesAt && now - this._lastLoadAddressesAt < 1500) {
        return;
      }
      this._lastLoadAddressesAt = now;

      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "get_user_addresses",
          nonce: checkoutCartParams.nonce,
        },
        success: (response) => {
          if (response.success && response.data.addresses) {
            this.displayAddresses(response.data.addresses);
            this.displaySelectedAddress(response.data.default_address);
            // repassa o preserveChosen (usado no reload do pagamento)
            this.calculateShipping({ preserveChosen: opts.preserveChosen === true });
          }
        },
      });
    },

    /**
     * Exibe endereço selecionado no resumo
     */
    displaySelectedAddress: function (address) {
      if (!address) return;

      // limpa a cópia antiga do resumo pra ela não sobrescrever esse endereço depois
      $("#selectedAddressSummary").removeData("original-html");

      const html = `
        <div class="address-card-display">
          <div class="address-details">
            <p class="address-name">${
              address.recipient_name || this.userData.fullName
            }</p>
            <p class="address-phone">${
              address.recipient_phone || this.userData.phone
            }</p>
            <p class="address-street">${address.address}, ${address.number}${
              address.complement ? " - " + address.complement : ""
            }</p>
            <p class="address-city">${address.neighborhood ? address.neighborhood + " - " : ""}${address.city}/${address.state} - ${
              address.cep
            }</p>
            ${
              address.instructions
                ? '<p class="address-note">Instruções de entrega: ' +
                  address.instructions +
                  "</p>"
                : ""
            }
          </div>
          <button type="button" class="btn-edit-address-icon" data-action="change">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.9834 5.15883L12.8412 2.01727C12.7367 1.91277 12.6127 1.82988 12.4762 1.77333C12.3397 1.71678 12.1933 1.68767 12.0456 1.68767C11.8978 1.68767 11.7515 1.71678 11.615 1.77333C11.4785 1.82988 11.3545 1.91277 11.25 2.01727L2.57977 10.6875C2.47485 10.7916 2.39167 10.9155 2.33506 11.052C2.27844 11.1885 2.24953 11.3349 2.25001 11.4827V14.625C2.25001 14.9234 2.36853 15.2095 2.57951 15.4205C2.79049 15.6315 3.07664 15.75 3.37501 15.75H15.1875C15.3367 15.75 15.4798 15.6907 15.5853 15.5852C15.6907 15.4798 15.75 15.3367 15.75 15.1875C15.75 15.0383 15.6907 14.8952 15.5853 14.7898C15.4798 14.6843 15.3367 14.625 15.1875 14.625H8.10844L15.9834 6.75C16.0879 6.64553 16.1708 6.5215 16.2274 6.38499C16.2839 6.24848 16.313 6.10217 16.313 5.95441C16.313 5.80665 16.2839 5.66034 16.2274 5.52384C16.1708 5.38733 16.0879 5.2633 15.9834 5.15883ZM6.51727 14.625H3.37501V11.4827L9.56251 5.29523L12.7048 8.4375L6.51727 14.625ZM13.5 7.64227L10.3584 4.5L12.0459 2.8125L15.1875 5.95477L13.5 7.64227Z" fill="#404040"/>
            </svg>
          </button>
        </div>
      `;

      $("#selectedAddressSummary").html(html);

      // Armazena endereço selecionado
      this.selectedAddress = address;
    },

    /**
     * Exibe lista de endereços
     */
    displayAddresses: function (addresses) {
      let html = "";

      addresses.forEach((addr, index) => {
        html += `
          <div class="address-item ${addr.is_default ? "address-default" : ""}">
            <label class="address-radio-label">
              <input type="radio" name="selected_address" value="${index}" ${
                addr.is_default ? "checked" : ""
              } />
              <div class="address-content">
                ${
                  addr.is_default
                    ? '<span class="badge-default">Padrão</span>'
                    : ""
                }
                <strong>${addr.recipient_name || ""}</strong>
                <p>(${addr.recipient_phone || ""})</p>
                <p>${addr.address}, ${addr.number}${
                  addr.complement ? " - " + addr.complement : ""
                }</p>
                <p>${addr.neighborhood} - ${addr.city}/${addr.state} - ${
                  addr.cep
                }</p>
                ${
                  addr.instructions
                    ? '<p class="instructions-text">Instruções: ' +
                      addr.instructions +
                      "</p>"
                    : ""
                }
              </div>
            </label>
          </div>
        `;
      });

      $("#addressesList").html(html);
    },

    /**
     * Calcula métodos de entrega
     */
    calculateShipping: function (opts) {
      opts = opts || {};

      if (!this.selectedAddress) {
        return;
      }

      $("#shippingMethodsList").html(
        '<div class="loading-shipping"><p>Calculando métodos de entrega...</p></div>',
      );

      const requestData = {
        action: "calculate_shipping_methods",
        nonce: checkoutCartParams.nonce,
        postcode: this.selectedAddress.cep,
        city: this.selectedAddress.city,
        state: this.selectedAddress.state,
      };

      // no reload, mantém o frete que já estava salvo na sessão
      if (opts.preserveChosen) {
        requestData.preserve_chosen = 1;
      }

      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: requestData,
        success: (response) => {
          if (response.success && response.data.methods) {
            this.displayShippingMethods(
              response.data.methods,
              response.data.cart_total,
              response.data.default_id,
            );
          } else {
            $("#shippingMethodsList").html(`
              <div class="no-shipping">
                <p>${
                  response.data.message || "Nenhum método de entrega disponível"
                }</p>
              </div>
            `);
          }
        },
        error: () => {
          $("#shippingMethodsList").html(`
            <div class="no-shipping">
              <p>Erro ao calcular frete. Tente novamente.</p>
            </div>
          `);
        },
      });
    },

    /**
     * Exibe métodos de entrega
     */
    displayShippingMethods: function (methods, cartTotal, defaultId) {

      // Se a lista de IDs disponíveis é a mesma já renderizada no DOM,
      // não re-renderiza — isso preservaria a seleção do usuário. O
      // refresh só vale a pena quando algum método entrou ou saiu.
      const currentIds = Array.from(
        document.querySelectorAll('input[type="radio"][name="shipping_method[0]"]'),
      )
        .map((r) => r.value)
        .filter(Boolean)
        .sort()
        .join(",");
      const newIds = methods.map((m) => m.id).sort().join(",");
      const hasCheckedRadio =
        document.querySelector('input[type="radio"][name="shipping_method[0]"]:checked') !== null;
      if (currentIds && currentIds === newIds && hasCheckedRadio) {
        return;
      }

      // Se o intent do usuário não está mais na lista nova, descarta.
      if (
        window.__userIntentShippingMethod &&
        !methods.some((m) => m.id === window.__userIntentShippingMethod)
      ) {
        window.__userIntentShippingMethod = null;
      }

      // Fonte da verdade: defaultId vem do backend (regra única em
      // jabuticaba_pick_default_shipping_method). Fallbacks só existem
      // para callsites legados que ainda não passam o defaultId.
      const persistedSelectedMethod =
        $('input[name="shipping_method[0]"]:checked').val() ||
        $("#shipping_method_0").val() ||
        "";
      const resolvedDefaultId =
        defaultId ||
        persistedSelectedMethod ||
        (methods.find((m) => m.type === "free_shipping") || {}).id ||
        (methods.find((m) => m.type !== "local_pickup") || {}).id ||
        (methods[0] || {}).id ||
        null;

      let html = "";

      methods.forEach((method) => {
        const cost = parseFloat(method.cost || 0);
        const costFormatted = cost.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        });
        const isChecked = method.id === resolvedDefaultId ? "checked" : "";
        const isLocalPickup =
          typeof method.id === "string" &&
          method.id.indexOf("local_pickup") === 0;
        const shippingEstimateMessage = isLocalPickup
          ? "Retirada em até 4 dias"
          : "Entrega a partir de 2 dias úteis";
        const resolvedShippingEstimateMessage =
          method.delivery_time || shippingEstimateMessage;
        const iconHtml = method.icon_url
          ? `<img class="shipping-method-icon" src="${method.icon_url}" alt="${method.label}" />`
          : "";
        html += `
          <label class="shipping-method-card">
            <div class="shipping-method-left">
              ${iconHtml}
              <div class="shipping-info">
                <p class="shipping-name">${method.label}</p>
                <p class="shipping-estimate">${resolvedShippingEstimateMessage}</p>
              </div>
            </div>
            <div class="shipping-method-right">
              <span class="shipping-price">${costFormatted}</span>
              <input type="radio" name="shipping_method[0]" data-index="0" value="${
                method.id
              }" data-cost="${cost}" ${isChecked} />
            </div>
          </label>
        `;
      });

      $("#shippingMethodsList").html(html);

      // FIX: popula o hidden e o userIntent imediatamente após renderizar,
      // sem esperar o AJAX do updateTotal. Evita race condition onde o usuário
      // abre o modal de agendamento antes do AJAX completar e o hidden fica "".
      if (resolvedDefaultId) {
        $("#shipping_method_0").val(resolvedDefaultId);
        // Só seta o userIntent se o usuário ainda não clicou em nada —
        // não queremos sobrescrever uma escolha humana com o auto-select.
        if (!window.__userIntentShippingMethod) {
          window.__userIntentShippingMethod = resolvedDefaultId;
        }
      }

      // Atualiza total ao selecionar metodo
      $(document).off(
        "change.shippingTotalSync",
        'input[name="shipping_method[0]"]',
      );
      $(document).on(
        "change.shippingTotalSync",
        'input[name="shipping_method[0]"]',
        () => {
          this.updateTotal();
          if (typeof toggleLocalPickupUI === 'function') toggleLocalPickupUI();
        },
      );

      const toggleLocalPickupUI = () => {
        const selectedMethod = $('input[name="shipping_method[0]"]:checked').val() || "";
        const isLocalPickup = selectedMethod.indexOf("local_pickup") === 0;

        if (isLocalPickup) {
           $("#btnScheduleDelivery").hide();
           
           const fallbackLabel = `
                 <p style="margin: 0; padding-bottom: 2px;">Rua Solon, 1050 - Bom Retiro</p>
                 <p style="margin: 0; padding-bottom: 15px;">São Paulo - SP, 01127-010</p>
                 <p style="margin: 0; padding-bottom: 2px;">9h ás 16h</p>
                 <p style="margin: 0;"><strong>Retirada a partir de 4 dias úteis</strong></p>
           `;
           const labelContent = (typeof checkoutCartParams !== 'undefined' && checkoutCartParams.label_retirada_checkout) 
                                ? checkoutCartParams.label_retirada_checkout 
                                : fallbackLabel;

           const localPickupHtml = `
             <div class="address-card-display local-pickup-card" style="display: flex; gap: 16px; align-items: flex-start; margin-top: 10px;">
               <div class="icon">
                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                   <path d="M12 6C11.2583 6 10.5333 6.21993 9.91661 6.63199C9.29993 7.04404 8.81928 7.62971 8.53545 8.31494C8.25162 9.00016 8.17736 9.75416 8.32205 10.4816C8.46675 11.209 8.8239 11.8772 9.34835 12.4017C9.8728 12.9261 10.541 13.2833 11.2684 13.4279C11.9958 13.5726 12.7498 13.4984 13.4351 13.2145C14.1203 12.9307 14.706 12.4501 15.118 11.8334C15.5301 11.2167 15.75 10.4917 15.75 9.75C15.75 8.75544 15.3549 7.80161 14.6517 7.09835C13.9484 6.39509 12.9946 6 12 6ZM12 12C11.555 12 11.12 11.868 10.75 11.6208C10.38 11.3736 10.0916 11.0222 9.92127 10.611C9.75097 10.1999 9.70642 9.7475 9.79323 9.31105C9.88005 8.87459 10.0943 8.47368 10.409 8.15901C10.7237 7.84434 11.1246 7.63005 11.561 7.54323C11.9975 7.45642 12.4499 7.50097 12.861 7.67127C13.2722 7.84157 13.6236 8.12996 13.8708 8.49997C14.118 8.86998 14.25 9.30499 14.25 9.75C14.25 10.3467 14.0129 10.919 13.591 11.341C13.169 11.7629 12.5967 12 12 12ZM12 1.5C9.81273 1.50248 7.71575 2.37247 6.16911 3.91911C4.62247 5.46575 3.75248 7.56273 3.75 9.75C3.75 12.6938 5.11031 15.8138 7.6875 18.7734C8.84552 20.1108 10.1489 21.3151 11.5734 22.3641C11.6995 22.4524 11.8498 22.4998 12.0037 22.4998C12.1577 22.4998 12.308 22.4524 12.4341 22.3641C13.856 21.3147 15.1568 20.1104 16.3125 18.7734C18.8859 15.8138 20.25 12.6938 20.25 9.75C20.2475 7.56273 19.3775 5.46575 17.8309 3.91911C16.2843 2.37247 14.1873 1.50248 12 1.5ZM12 20.8125C10.4503 19.5938 5.25 15.1172 5.25 9.75C5.25 7.95979 5.96116 6.2429 7.22703 4.97703C8.4929 3.71116 10.2098 3 12 3C13.7902 3 15.5071 3.71116 16.773 4.97703C18.0388 6.2429 18.75 7.95979 18.75 9.75C18.75 15.1153 13.5497 19.5938 12 20.8125Z" fill="#262626"/>
                 </svg>
               </div>
               <div class="address-details" style="font-size: 15px; color: #525252; line-height: 1.4; text-align: left; font-family: 'Inter', sans-serif; font-weight: 500;">
                 ${labelContent}
               </div>
             </div>
           `;
           if (!$("#selectedAddressSummary").data("original-html")) {
             $("#selectedAddressSummary").data("original-html", $("#selectedAddressSummary").html());
           }
           $("#selectedAddressSummary").html(localPickupHtml);
        } else {
           $("#btnScheduleDelivery").show();
           // usa o endereço atual, não a cópia salva (que podia ficar
           // desatualizada se o usuário trocasse de endereço). cópia só como fallback.
           $("#selectedAddressSummary").removeData("original-html");
           if (this.selectedAddress) {
             this.displaySelectedAddress(this.selectedAddress);
           } else {
             const originalHtml = $("#selectedAddressSummary").data("original-html");
             if (originalHtml) {
               $("#selectedAddressSummary").html(originalHtml);
             }
           }
        }
      };

      // ===== CONTROLE DO BOTAO: metodo de entrega + data =====
      const updateConfirmShippingButton = () => {
        const $btn = $("#btnConfirmShipping");
        const selectedMethod = $('input[name="shipping_method[0]"]:checked').val() || "";
        const hasMethod = selectedMethod.length > 0;
        const isLocalPickup = selectedMethod.indexOf("local_pickup") === 0;
        const dateValue = $("#e_deliverydate_0").val();
        const hasDate = dateValue && dateValue.trim() !== "";

        if (hasMethod && (hasDate || isLocalPickup)) {
          $btn.prop("disabled", false).removeClass("disabled");
        } else {
          $btn.prop("disabled", true).addClass("disabled");
        }
      };

      $(document).off("change.confirmShipping", "#e_deliverydate_0");
      $(document).on(
        "change.confirmShipping",
        "#e_deliverydate_0",
        updateConfirmShippingButton,
      );

      $(document).off(
        "change.confirmShipping",
        'input[name="shipping_method[0]"]',
      );
      $(document).on(
        "change.confirmShipping",
        'input[name="shipping_method[0]"]',
        updateConfirmShippingButton,
      );

      window.updateConfirmShippingButton = updateConfirmShippingButton;

      // Expõe globalmente para que outros módulos (ex: checkout-cart.js) possam
      // re-renderizar os métodos quando o cart for alterado (qty/cupom).
      window.jabuticabaRefreshShippingMethods = (methods, cartTotal, defaultId) => {
        if (Array.isArray(methods) && methods.length > 0) {
          this.displayShippingMethods(methods, cartTotal, defaultId);
        }
      };

      updateConfirmShippingButton();
      toggleLocalPickupUI();

      // Atualiza total inicial
      this.updateTotal();
    },

    /**
     * Atualiza total com frete
     */
    updateTotal: function () {
      const selectedMethod = $('input[name="shipping_method[0]"]:checked');
      const shippingCost = parseFloat(selectedMethod.data("cost") || 0);
      const methodValue = selectedMethod.val();

      // Guard contra chamadas duplicadas: se o último save foi o mesmo método
      // dentro de 1s, ignora. Isso evita que dois `change` consecutivos (ex:
      // re-render do displayShippingMethods + clique do usuário) sobrescrevam
      // a sessão com o método antigo.
      const now = Date.now();
      if (
        this._lastSavedShippingMethod === methodValue &&
        this._lastSavedShippingAt &&
        now - this._lastSavedShippingAt < 1000
      ) {
        return;
      }
      this._lastSavedShippingMethod = methodValue;
      this._lastSavedShippingAt = now;

      // Salva o método de entrega no backend para atualizar a sessão e pega o total recalculado
      $.ajax({
        url: checkoutCartParams.ajax_url,
        type: "POST",
        dataType: "json",
        data: {
          action: "save_shipping_method",
          nonce: checkoutCartParams.nonce,
          shipping_method: methodValue,
        },
        success: (response) => {
          if (response.success) {
            // Guarda o método salvo pelo backend (referência informativa).
            // NÃO força o radio do DOM para esse valor — quem manda é o
            // __userIntentShippingMethod (último clique humano).
            const sessionMethod =
              (response.data.chosen_shipping_methods &&
                response.data.chosen_shipping_methods[0]) ||
              methodValue;

            // FIX: o hidden e o lastConfirmed devem refletir o que o USUÁRIO
            // escolheu (methodValue enviado), não o que o backend devolveu após
            // recalcular — o backend pode trocar o método por regra de frete
            // grátis/local_pickup, mas quem manda aqui é o intent do usuário.
            // O userIntent é a fonte de verdade; o hidden sincroniza com ele.
            const effectiveMethod = window.__userIntentShippingMethod || methodValue;
            window.__lastConfirmedShippingMethod = effectiveMethod;
            $("#shipping_method_0").val(effectiveMethod);

            const cartTotal = parseFloat(response.data.cart_total || response.data.total || 0);
            const finalTotal = cartTotal;

            const formattedTotal = finalTotal.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            });

            $("#totalWithShipping").text(formattedTotal);
            $("#paymentTotalWithShipping").text(formattedTotal);
            
            // Atualiza os totais na lateral (resumo do carrinho)
            $(".checkout-cart-total .total-value").html(formattedTotal);
            
            if (response.data.cart_subtotal !== undefined) {
              const subtotalFormatted = parseFloat(response.data.cart_subtotal).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              });
              $(".checkout-cart-subtotal .subtotal-value").html(subtotalFormatted);
            }
          }
        },
      });
    },
  };

  // ===== BLOQUEIO DO update_checkout DURANTE MODAL DE AGENDAMENTO =====
  // O plugin ORDDD dispara jQuery("body").trigger("update_checkout") toda vez
  // que o usuário seleciona uma data. O WC nativo, ao processar esse evento,
  // re-renderiza o form de checkout incluindo os radios de frete — marcando o
  // método que está na sessão do backend, não o que o usuário escolheu.
  // Solução: sobrescrevemos o handler do update_checkout enquanto o modal de
  // agendamento está aberto, restaurando após fechar.
  (function () {
    const MODAL_ID = "modalScheduleDelivery";

    function isModalOpen() {
      const el = document.getElementById(MODAL_ID);
      return el && el.classList.contains("show");
    }

    // Intercepta o update_checkout quando modal está aberto
    $(document.body).on("update_checkout.orddd_block", function (e) {
      if (isModalOpen()) {
        e.stopImmediatePropagation();
        return false;
      }
    });
  })();

  // Inicializa quando o documento estiver pronto
  $(document).ready(function () {
    CheckoutAuth.init();

    // Variável para armazenar dados de entrega temporariamente
    let deliveryData = {
      date: "",
      time: "",
      dateFormatted: "",
    };

    // Função auxiliar para abrir modal
    function openModal($modal) {
      const $body = $("body");
      $(".modal-backdrop").remove();

      const $backdrop = $("<div class='modal-backdrop fade'></div>");
      $backdrop.appendTo("body");

      $modal.css({
        position: "fixed",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        "z-index": "1055",
        display: "block",
      });

      setTimeout(() => {
        $backdrop.addClass("show");
        $modal.addClass("show");
      }, 10);

      $body.addClass("modal-open");
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;
      $body.css("padding-right", scrollbarWidth + "px");
    }

    // Função auxiliar para fechar modal
    function closeModal($modal) {
      const $backdrop = $(".modal-backdrop");
      $modal.removeClass("show");
      $backdrop.removeClass("show");

      setTimeout(() => {
        $modal.css("display", "none");
        $backdrop.remove();
        $("body").removeClass("modal-open").css("padding-right", "");
      }, 300);
    }

    // Event listener para abrir o modal de agendamento
    $(document).on("click", "#btnScheduleDelivery", function (e) {
      e.preventDefault();
      e.stopPropagation();
      openModal($("#modalScheduleDelivery"));
    });

    // Event listener para salvar a data e abrir modal de confirmação
    $(document).on("click", "#btnSaveDeliveryDate", function (e) {
      e.preventDefault();

      // Captura a data selecionada do plugin Order Delivery Date
      // Tente diferentes seletores comuns do plugin
      let selectedDate = "";
      let selectedTime = "";

      // Opção 1: Campo input de data
      const $dateInput = $(
        '#modalScheduleDelivery input[name*="delivery"], #modalScheduleDelivery input[type="date"], #modalScheduleDelivery .e-deliverydate',
      ).first();
      if ($dateInput.length && $dateInput.val()) {
        selectedDate = $dateInput.val();
      }

      // Opção 2: Select de data
      const $dateSelect = $(
        '#modalScheduleDelivery select[name*="delivery_date"]',
      ).first();
      if ($dateSelect.length && $dateSelect.val()) {
        selectedDate = $dateSelect.find("option:selected").text();
      }

      // Opção 3: Texto exibido (para calendários customizados)
      const $dateDisplay = $(
        "#modalScheduleDelivery .orddd_display_date, #modalScheduleDelivery .delivery-date-display",
      ).first();
      if ($dateDisplay.length && $dateDisplay.text()) {
        selectedDate = $dateDisplay.text();
      }

      // Captura horário se existir
      const $timeSelect = $(
        '#modalScheduleDelivery select[name*="time"], #modalScheduleDelivery select[name*="timeslot"]',
      ).first();
      if ($timeSelect.length && $timeSelect.val()) {
        selectedTime = $timeSelect.find("option:selected").text();
      }

      // Se não encontrou data, tenta pegar qualquer input/select visível com valor
      if (!selectedDate) {
        const $anyInput = $(
          "#modalScheduleDelivery input, #modalScheduleDelivery select",
        )
          .filter(function () {
            return (
              $(this).is(":visible") && $(this).val() && $(this).val() !== ""
            );
          })
          .first();
        if ($anyInput.length) {
          selectedDate = $anyInput.val();
        }
      }

      // Fallback: usa data atual se não conseguiu capturar
      if (!selectedDate || selectedDate === "") {
        const today = new Date();
        const options = {
          day: "2-digit",
          month: "long",
          year: "numeric",
        };
        selectedDate = today.toLocaleDateString("pt-BR", options);
        console.warn(
          "Não foi possível capturar a data do plugin. Usando data atual.",
        );
      }

      // Armazena os dados
      deliveryData.date = selectedDate;
      deliveryData.time = selectedTime;
      deliveryData.dateFormatted = selectedDate;

      // Pega o endereço selecionado
      const $addressSummary = $("#selectedAddressSummary");
      let addressHTML = "";

      if ($addressSummary.length && $addressSummary.html().trim() !== "") {
        addressHTML = $addressSummary.html();
      } else {
        addressHTML = "<p>Nenhum endereço selecionado</p>";
      }

      // Preenche o modal de confirmação
      $("#confirmationDeliveryDate").text(deliveryData.dateFormatted);

      if (deliveryData.time && deliveryData.time !== "") {
        $("#confirmationDeliveryTime")
          .text("Melhor horário: " + deliveryData.time)
          .show();
      } else {
        $("#confirmationDeliveryTime").hide();
      }

      $("#confirmationAddress").html(addressHTML);

      // Fecha o modal de seleção e abre o de confirmação
      closeModal($("#modalScheduleDelivery"));
      setTimeout(() => {
        openModal($("#modalDeliveryConfirmation"));
      }, 350);
    });

    // Event listener para "ALTERAR ENTREGA" - volta para modal de seleção
    $(document).on("click", "#btnChangeDelivery", function (e) {
      e.preventDefault();
      closeModal($("#modalDeliveryConfirmation"));
      setTimeout(() => {
        openModal($("#modalScheduleDelivery"));
      }, 350);
    });

    // Event listener para "SALVAR" final - fecha tudo
    $(document).on("click", "#btnConfirmDelivery", function (e) {
      e.preventDefault();

      if (deliveryData.date) {
        const $dateInput = $("#e_deliverydate_0");
        if ($dateInput.length) {
          $dateInput.val(deliveryData.date);
          $dateInput.trigger("change");
        }
      }

      if (typeof window.updateConfirmShippingButton === "function") {
        window.updateConfirmShippingButton();
      }

      closeModal($("#modalDeliveryConfirmation"));
    });

    // Event listener para fechar modais pelo X
    $(document).on("click", ".btn-close-delivery", function (e) {
      e.preventDefault();
      const $modal = $(this).closest(".modal");
      closeModal($modal);
    });

    // Fechar modal ao clicar no backdrop
    $(document).on("click", ".modal-backdrop", function () {
      const $openModal = $(".modal.show");
      if ($openModal.length) {
        closeModal($openModal);
      }
    });
  });

  // Expõe CheckoutAuth globalmente para uso no template
  window.CheckoutAuth = CheckoutAuth;
})(jQuery);
